import React from 'react';
import styles from './index.module.scss'; // Import the Sass file
import { v4 as uuidv4 } from 'uuid';

interface ISwitch extends React.InputHTMLAttributes<HTMLInputElement> {
  id?: string;
  checked?: boolean;
  headerText?: React.ReactNode;
}

const Switch: React.FC<ISwitch> = ({ id = uuidv4(), checked, headerText, ...restProps }) => {
  return (
    <div className={styles.switchContainer}>
      <input
        type="checkbox"
        id={id}
        className={styles.switchInput}
        checked={checked}
        {...restProps}
      />
      <label htmlFor={id} className={styles.switchLabel}>
        <div className={styles.switchInner}></div>
      </label>
      {headerText ? (
        <label htmlFor={id} className={styles.headerText}>
          {headerText}
        </label>
      ) : null}
    </div>
  );
};

export default Switch;
